/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SurgicalOptionsAliases {
  PATIENT_ROOM_CHECK_BUTTON = 'patient-room-check-button',
  PATIENT_ROOM_CHECK_PANEL = 'patient-room-check-panel',
  SURGICAL_OPTIONS_LAYOUT = 'surgical-options-layout',
  SURGICAL_OPTIONS_PANEL = 'surgical-options-panel',
}
export { SurgicalOptionsAliases };
